import { IClassname } from '@/lib/shared/model/classname';

export const Shuttle = ({ className }: IClassname) => {
  return (
    <svg
      className={className}
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M23.0925 25.5846H21.7507V20.4729L24.9455 16.6392H26.8624C27.8792 16.6392 28.8543 17.0431 29.5733 17.762C30.2922 18.481 30.6961 19.4561 30.6961 20.4729V25.5846H29.3543"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.54652 25.5846H14.0831V21.7508C14.0831 21.4119 13.9485 21.0869 13.7088 20.8472C13.4692 20.6075 13.1441 20.4729 12.8052 20.4729H8.97146V17.9171C8.97146 17.5782 8.83682 17.2531 8.59716 17.0135C8.35751 16.7738 8.03246 16.6392 7.69354 16.6392H3.85979C3.18194 16.6392 2.53185 16.9084 2.05254 17.3877C1.57323 17.8671 1.30396 18.5171 1.30396 19.195V24.9456C1.30396 25.1151 1.37127 25.2776 1.4911 25.3974C1.61093 25.5173 1.77345 25.5846 1.94291 25.5846H3.28473"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.083 25.5845H21.7505"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.5474 5.56333C25.5816 5.65968 25.5921 5.76283 25.5781 5.8641C25.5642 5.96536 25.5261 6.0618 25.4671 6.14531C25.4081 6.22881 25.33 6.29695 25.2392 6.344C25.1485 6.39105 25.0478 6.41564 24.9455 6.4157H1.94304C1.84081 6.41564 1.74009 6.39105 1.64933 6.344C1.55857 6.29695 1.48043 6.22881 1.42146 6.14531C1.36249 6.0618 1.32442 5.96536 1.31044 5.8641C1.29647 5.76283 1.30699 5.65968 1.34114 5.56333C1.51741 5.06502 1.84385 4.63363 2.27548 4.32855C2.70712 4.02348 3.22272 3.85973 3.75129 3.85986H23.1373C23.6658 3.85973 24.1815 4.02348 24.6131 4.32855C25.0447 4.63363 25.3712 5.06502 25.5474 5.56333Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.1377 16.6389V6.41553"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.22095 24.9453C3.22095 25.7926 3.55754 26.6052 4.15668 27.2043C4.75582 27.8035 5.56843 28.1401 6.41574 28.1401C7.26305 28.1401 8.07566 27.8035 8.6748 27.2043C9.27394 26.6052 9.61053 25.7926 9.61053 24.9453C9.61053 24.098 9.27394 23.2854 8.6748 22.6862C8.07566 22.0871 7.26305 21.7505 6.41574 21.7505C5.56843 21.7505 4.75582 22.0871 4.15668 22.6862C3.55754 23.2854 3.22095 24.098 3.22095 24.9453Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23.0286 24.9453C23.0286 25.3648 23.1112 25.7803 23.2718 26.1679C23.4323 26.5555 23.6676 26.9077 23.9643 27.2043C24.261 27.501 24.6132 27.7363 25.0008 27.8969C25.3884 28.0574 25.8038 28.1401 26.2234 28.1401C26.6429 28.1401 27.0583 28.0574 27.4459 27.8969C27.8336 27.7363 28.1858 27.501 28.4824 27.2043C28.7791 26.9077 29.0144 26.5555 29.175 26.1679C29.3355 25.7803 29.4181 25.3648 29.4181 24.9453C29.4181 24.098 29.0816 23.2854 28.4824 22.6862C27.8833 22.0871 27.0707 21.7505 26.2234 21.7505C25.376 21.7505 24.5634 22.0871 23.9643 22.6862C23.3652 23.2854 23.0286 24.098 23.0286 24.9453Z"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.4727 16.6392L22.9122 19.0787"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.1948 17.9167L21.7507 15.3608"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24.9453 16.6389L21.1116 6.41553"
        stroke="#22364A"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
